import React from 'react'
import { makeStyles } from '@mui/styles'

import { BackButton } from '@/modules/base/components/buttons'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 40px',
    marginBottom: !theme.IsMeinbuero ? 0 : 30,
    '@media screen and (min-height: 860px)': {
      marginBottom: 0,
    },
  },
  containerRight: {
    display: 'flex',
  },
  backButton: {
    color: '#575d6b',
    padding: '0',
    display: 'flex',
    justifyContent: 'flex-start',
  },
}))

const ModalFooter = (props) => {
  const classes = useStyles()
  const { children, customClass, hasBackButton, onBackButtonClicked } = props

  const backButton = hasBackButton || onBackButtonClicked
    ? <BackButton onClick={onBackButtonClicked} customClass={classes.backButton} />
    : <div></div>

  return (
    <div className={`${classes.container} ${customClass || ''} modal-footer`}>
      {backButton}
      <div className={classes.containerRight}>
        {children}
      </div>
    </div>
  )
}

ModalFooter.defaultProps = {
  hasBackButton: false,
}

export default ModalFooter
